/**
 * Usuarios de ADMINISTRACION (backoffice), no de cuenta.
 *
 * Lo que abre el admin es el ROL DEL TOKEN de Keycloak, no una fila en la BD,
 * así que el identificador de estos registros es el id de Keycloak (`id`) y
 * no el Guid local (`localUserId`, que puede no existir). Ver
 * `notify.admin.api/Service/Services/PlatformUserService.cs`.
 */

/** Nombres del enum `UserRole` del backend. */
export type PlatformRoleName = 'SuperUser' | 'Maintenance';

/** Valores del enum tal y como los acepta el backend en el cuerpo (1 / 2). */
export const PLATFORM_ROLE_ID: Record<PlatformRoleName, number> = {
  SuperUser: 1,
  Maintenance: 2,
};

export interface PlatformUserRecord {
  /** Id de Keycloak. Clave de todas las operaciones. */
  id: string;
  /** Guid de la fila local de `users`, si la tiene. */
  localUserId?: string | null;
  email?: string | null;
  name?: string | null;
  surname?: string | null;
  enabled: boolean;
  /**
   * El backend serializa el enum en camelCase (`superUser` / `maintenance`);
   * `roleName` viene ya en PascalCase y es el que conviene leer.
   */
  role: string;
  roleName: PlatformRoleName;
  /** Roles concedidos en el cliente de notify (nombres crudos de Keycloak). */
  clientRoles: string[];
  /** Roles de realm que le dan acceso (nombres crudos de Keycloak). */
  realmRoles: string[];
  /**
   * false = su acceso viene SOLO de un rol de realm. El realm es compartido
   * con el resto de productos Roommatik, así que esta pantalla no lo cambia.
   */
  managedHere: boolean;
  /** Cuenta de servicio de Keycloak (client credentials), no una persona. */
  serviceAccount: boolean;
  /** Tiene ficha en `users`; sin ella "Mi perfil" no carga. */
  hasLocalProfile: boolean;
}

export interface PlatformUserCreatePayload {
  email: string;
  name?: string;
  surname?: string;
  /** Numérico: el backend lo deserializa como `UserRole`. */
  role: number;
  /** Vacío = Keycloak le envía el correo para establecer contraseña. */
  password?: string;
}

export interface PlatformUserUpdatePayload {
  email?: string;
  name?: string;
  surname?: string;
  /** Omitido = no tocar el rol. */
  role?: number;
}

export interface PlatformUserFormValues {
  email: string;
  name: string;
  surname: string;
  roleName: PlatformRoleName;
  password: string;
}
